//     (() => {
//   function normalizeQuantity(formData, form) {
//     formData.delete('quantity');
//     const qtyInput =
//       form.querySelector('[name="quantity"]') ||
//       document.querySelector('.quantity__input');
//     const quantity = qtyInput && qtyInput.value ? qtyInput.value : 1;
//     formData.set('quantity', quantity);
//   }
//   const originalFetch = window.fetch;
//   window.fetch = function (url, config) {
//     if (
//       typeof url === 'string' &&
//       url.includes('/cart/add') &&
//       config?.body instanceof FormData
//     ) {
//       const form = document.querySelector('form[data-type="add-to-cart-form"]');
//       if (form) {
//         normalizeQuantity(config.body, form);
//       }
//     }
//     return originalFetch.apply(this, arguments);
//   };
//   document.addEventListener(
//     'submit',
//     function (event) {
//       const form = event.target;
//       if (!form.matches('form[data-type="add-to-cart-form"]')) return;
//       const qtyInputs = form.querySelectorAll('[name="quantity"]');
//       if (qtyInputs.length > 1) {
//         qtyInputs.forEach((input, index) => {
//           if (index < qtyInputs.length - 1) input.remove();
//         });
//       }
//     },
//     true
//   );
// })();

(() => {
  let activeAddToCartForm = null;

  function getFormQuantityInput(form) {
    const productForm = form.closest('product-form');
    const productContainer =
      productForm?.closest('product-info') ||
      productForm?.closest('.product') ||
      productForm?.parentElement;

    return (
      productContainer?.querySelector('.product-form__quantity [name="quantity"]') ||
      productContainer?.querySelector('quantity-input [name="quantity"]') ||
      productContainer?.querySelector('[name="quantity"]')
    );
  }

  function normalizeQuantity(formData, form) {
    formData.delete('quantity');
    const qtyInput = getFormQuantityInput(form);
    const quantity = qtyInput && qtyInput.value ? qtyInput.value : 1;
    formData.set('quantity', quantity);
  }

  const originalFetch = window.fetch;
  window.fetch = function (url, config) {
    if (
      typeof url === 'string' &&
      url.includes('/cart/add') &&
      config?.body instanceof FormData
    ) {
      const form =
        activeAddToCartForm ||
        document.activeElement?.closest?.('form[data-type="add-to-cart-form"]');
      if (form) {
        normalizeQuantity(config.body, form);
      } else if (!config.body.has('quantity')) {
        config.body.set('quantity', 1);
      }
    }
    return originalFetch.apply(this, arguments);
  };
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!form.matches('form[data-type="add-to-cart-form"]')) return;
      activeAddToCartForm = form;
      const qtyInputs = form.querySelectorAll('[name="quantity"]');
      if (qtyInputs.length > 1) {
        qtyInputs.forEach((input, index) => {
          if (index < qtyInputs.length - 1) input.remove();
        });
      }
      setTimeout(() => {
        if (activeAddToCartForm === form) activeAddToCartForm = null;
      }, 0);
    },
    true
  );
})();
